import { Box, Chip, Link as MuiLink, Stack, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ROUTES } from '@/utils/constants'
import { formatDateDMY } from '@/utils/date'
import type { UserStub } from '@/types/dashboard'
import type { WidgetProps } from './WidgetProps'
import { EmptyHint } from './EmptyHint'

interface GrantRow {
  id: number
  contract_id: number
  student: UserStub | null
  plan_title: string | null
  lessons_remaining: number
  lessons_total: number
  expires_at: string | null
}

export function SubscriptionsExpiringWidget({ payload }: WidgetProps) {
  const { t } = useTranslation()
  const grants = (payload.grants ?? []) as GrantRow[]

  if (grants.length === 0) {
    return <EmptyHint fallbackKey="dashboard.widgets.subscriptions_expiring.empty" />
  }

  return (
    <Stack spacing={1}>
      {grants.map((grant) => (
        <Box key={grant.id} sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
          {grant.student ? (
            <MuiLink
              component={Link}
              to={ROUTES.USER_FINANCE(grant.student.id)}
              variant="body2"
              noWrap
              sx={{ flexGrow: 1, minWidth: 0 }}
            >
              {grant.student.name}
            </MuiLink>
          ) : (
            <Typography variant="body2" sx={{ flexGrow: 1 }}>
              —
            </Typography>
          )}
          <Chip
            size="small"
            color={grant.lessons_remaining <= 1 ? 'warning' : 'default'}
            label={t('dashboard.widgets.subscriptions_expiring.lessonsLeft', {
              count: grant.lessons_remaining,
            })}
          />
          <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
            {t('dashboard.widgets.subscriptions_expiring.until', {
              date: formatDateDMY(grant.expires_at),
            })}
          </Typography>
        </Box>
      ))}
    </Stack>
  )
}
